import React, { useEffect, useState } from 'react';
import { subscribeToLiveChatSettings, LiveChatSettings } from '../lib/liveChatService';

interface CrispChatWidgetProps {
  isAdmin?: boolean;
}

export const CrispChatWidget: React.FC<CrispChatWidgetProps> = ({ isAdmin }) => {
  const [settings, setSettings] = useState<LiveChatSettings | null>(null);

  useEffect(() => {
    const unsub = subscribeToLiveChatSettings((newSettings) => {
      setSettings(newSettings);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!settings || !settings.enabled || !settings.websiteId || isAdmin) {
      // Remove Crisp if disabled or if user is admin
      if ((window as any).$crisp) {
        // Crisp doesn't easily support full removal without reloading, 
        // but we can hide it.
        try {
          (window as any).$crisp.push(['do', 'chat:hide']);
        } catch (e) {}
      }
      return;
    }

    // Check if we need to hide based on device
    const isMobile = window.innerWidth <= 768;
    if ((isMobile && !settings.mobileEnabled) || (!isMobile && !settings.desktopEnabled)) {
      if ((window as any).$crisp) {
        try {
          (window as any).$crisp.push(['do', 'chat:hide']);
        } catch(e) {}
      }
      return;
    }

    // Initialize Crisp
    if (!(window as any).$crisp) {
      (window as any).$crisp = [];
      (window as any).CRISP_WEBSITE_ID = settings.websiteId;
      (function() {
        const d = document;
        const s = d.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        d.getElementsByTagName('head')[0].appendChild(s);
      })();
    } else {
      // Show it if it was hidden
      try {
        (window as any).$crisp.push(['do', 'chat:show']);
      } catch (e) {}
    }

    // Apply specific settings
    if ((window as any).$crisp) {
      // Config position
      if (settings.position === 'left') {
        (window as any).$crisp.push(['config', 'position:reverse', [true]]);
      } else {
        (window as any).$crisp.push(['config', 'position:reverse', [false]]);
      }
      // Note: Theme color is typically set in Crisp Dashboard, 
      // but we can set session data or generic things. The user requested Purple.
      (window as any).$crisp.push(['config', 'color:theme', [settings.themeColor]]);
    }

  }, [settings]);

  return null;
};
